import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';
import { notifications } from '@mantine/notifications';

import { SendResetPasswordResponse } from '@/features/auth';

export type SendResetUserPasswordDTO = {
    data: {
        username: string;
    };
}

export const sendResetUserPassword = ({ data }: SendResetUserPasswordDTO): Promise<SendResetPasswordResponse> => {
    return axios.post(`/users/resetpassword`, data);
};

type UseSendResetPasswordUserOptions = {
    config? : MutationConfig<typeof sendResetUserPassword>;
};

export const useSendResetPasswordUser = ({ config }: UseSendResetPasswordUserOptions = {}) => {
    return useMutation({
        onMutate: async (resetingUser: any) => {
            await queryClient.cancelQueries(['sendResetUserPassword']);

            const previousUser = queryClient.getQueryData<Event>([
                'sendResetUserPassword',
            ]);

            queryClient.setQueryData(['sendResetUserPassword'], {
                ...previousUser,
                ...resetingUser.data,
                uuid: resetingUser.user_uuid,
            });

            return { previousUser };
        },
        onError: (_,__, context: any) => {
            if (context?.previousUser) {
                queryClient.setQueryData(
                    ['sendResetUserPassword'],
                    context.previousUser
                );
            }
            notifications.show({
                title: 'Error',
                message: 'An error occurred while sending the reset password link ❌',
                color: 'red'
            });
        },
        onSuccess: () => {
            queryClient.refetchQueries(['sendResetUserPassword']);
            notifications.show({
                title: 'Success!',
                message: 'Reset password link sent ✅',
                color: 'green'
            });
        },
        ...config,
        mutationFn: sendResetUserPassword
    });
}